import { Component, DestroyRef, HostBinding, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';
import { NavbarComponent } from '../../../shared/components/navbar/navbar.component';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { FooterComponent } from '../../../shared/components/footer/footer.component';

@Component({
    selector: 'app-principal-layout',
    standalone: true,
    imports: [RouterModule, NavbarComponent, MenuComponent, FooterComponent],
    templateUrl: './principal-layout.component.html',
    styleUrls: ['./principal-layout.component.css'],
})
export class PrincipalLayoutComponent implements OnInit {

    @Input() toogle = false;

    /** Landing `/` is the entry of the origination journey (PDF 3.1): Poppins for navbar, content and footer there only. */
    @HostBinding('class.font-poppins') landing = false;

    private readonly router = inject(Router);
    private readonly destroyRef = inject(DestroyRef);

    ngOnInit() {
        this.landing = this.esLanding(this.router.url);
        this.router.events
            .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd), takeUntilDestroyed(this.destroyRef))
            .subscribe((e) => (this.landing = this.esLanding(e.urlAfterRedirects)));
    }

    private esLanding(url: string): boolean {
        return url.split(/[?#]/)[0] === '/';
    }

    handleToogle(event: boolean) {
        this.toogle = event;
    }

    hideToogle(event: boolean) {
        this.toogle = event;
    }

}
